import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import NoItemsFound from '../components/NoItemsFound';
import DynamicTable from '../components/DynamicTable';
import TopBar from '../components/TopBar';
import TitleBackButton from '../components/TitleBackButton';
import LogoModal from '../components/LogoModal';

import {
  get_watchlists,
  get_logos,
  get_watchlist_logo_associations,
  logos_by_watchlist,
  associate_logos,
} from '../api/api';

const LogoPage = () => {
  const [loading, setLoading] = useState(true);
  const [logosData, setLogosData] = useState([]);
  const [watchlists, setWatchlists] = useState([]);
  const [teamSearch, setTeamSearch] = useState('');
  const [logos, setLogos] = useState([]);
  const [selections, setSelections] = useState({});

  const [modalOpen, setModalOpen] = useState(false);
  const [activeWatchlist, setActiveWatchlist] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const [wl, lg, rawassociations] = await Promise.all([
        get_watchlists(),
        get_logos(),
        get_watchlist_logo_associations(),
      ]);

      const watchlistsData = wl?.data?.results;
      const logoData = lg?.data?.results;


      logoData.sort((a, b) => a.name.localeCompare(b.name));


      setWatchlists(watchlistsData);
      setLogos(logoData);

      const associations = rawassociations.data.results;

      const initialSelections = {};
      for (const assoc of associations) {
        const logo = logoData.find(l => l.id === assoc.logo_id);
        if (logo) {
          initialSelections[assoc.watchlist_id] = {
            typology: logo.typology,
            logoId: logo.id,
          };
        }
      }

      setSelections(initialSelections);
      setLoading(false);
    }

    fetchData();
  }, []);

  const handleSaveSelection = (watchlistId, selection) => {
    associate_logos(watchlistId, selection);
  };

  return (
    <div>
      <TopBar />

      <div className="content">
        <div className="main-content">
          <div className="dynamic-table-topbar-right">
            <TitleBackButton title={"Gestione Loghi e Simboli"} />
          </div>

          <div className="team-search-bar">
            <input
              type="text"
              placeholder="Cerca squadra..."
              value={teamSearch}
              onChange={e => setTeamSearch(e.target.value)}
              className="field-input"
            />
          </div>

          <div className="team-list-long white-box">
            {!loading &&
              watchlists
                .filter(watchlist =>
                  watchlist.name.toLowerCase().includes(teamSearch.toLowerCase())
                )
                .map(watchlist => (
                  <div className="team-item-outer" key={watchlist.id}>
                    <div className="mb-2 font-semibold">{watchlist.name}</div>
                    <button
                      className="btn btn-primary btn-logo"
                      onClick={() => {
                        setActiveWatchlist(watchlist);
                        setModalOpen(true);
                      }}
                    >
                      Assegna Logo
                    </button>
                  </div>
                ))}
          </div>
        </div>
      </div>

      <LogoModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        watchlist={activeWatchlist}
        selection={selections[activeWatchlist?.id]}
        logos={logos}
        onSave={handleSaveSelection}
        fetchAssociatedLogos={logos_by_watchlist}
      />
    </div>
  );
};

export default LogoPage;
